import { type HighlightsController } from '@databases/highlights';
import { createFillHandleEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export interface FillHandleEffectFeatureDeps {
  highlightsController: HighlightsController;
}

export function createFillHandleEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.FILL_HANDLE_EFFECT,
    type: 'effect',
    isEnabled: (perms) => perms.canEditContent,
    factory: () => {
      const highlightsController = getService('TableHighlightsController');

      return createFillHandleEffect(highlightsController);
    },
  };
}
